<template>
    <div class="page" :class="{isPhonePage: isPhone}">
        <div class="base">
            <img src="http://img.cdboost.cn/cdboost/sy/cp02.jpg" alt="">
        </div>
        <div class="base" id="ID21">
            <div class="title-box">
                <span class="title">交流充电桩</span>
            </div>
            <div class="content">
                <ul class="leftCon">
                    <li v-for="item in list1" :class="item.cls" :style="{backgroundImage: `url(${item.img})`}">
                        <div class="title" :style="{color: item.color}">{{item.title}}</div>
                        <div class="text">{{item.text}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="base" id="ID22">
            <div class="title-box">
                <span class="title">电动自行车分布式充电桩</span>
            </div>
            <div class="content">
                <ul class="leftCon">
                    <li v-for="item in list2" :class="item.cls" :style="{backgroundImage: `url(${item.img})`}">
                        <div class="title" :style="{color: item.color}">{{item.title}}</div>
                        <div class="text">{{item.text}}</div>
                    </li>
                </ul>
            </div>
            <p>工作功率：标准设备单孔插座最大允许1200W输出，大功率设备最大允许3500W输出。</p>
        </div>
        <div class="base" id="ID23">
            <div class="title-box">
                <span class="title">电动自行车集中式充电桩</span>
            </div>
            <div class="content">
                <ul class="leftCon">
                    <li v-for="item in list3" :style="{backgroundImage: `url(${item.img})`}">
                        <div class="title" :style="{color: item.color}">{{item.title}}</div>
                        <div class="text">{{item.text}}</div>
                    </li>
                </ul>
            </div>
            <p>单路最大输出1100瓦，支持12路同时充电</p>
        </div>
        <div class="base" id="ID24">
            <img src="http://img.cdboost.cn/cdboost/sy/cp06.jpg" alt="">
        </div>
        <div class="base" id="ID25">
            <img src="http://img.cdboost.cn/cdboost/sy/cp07.jpg" alt="">
        </div>
    </div>
</template>

<script>
    import {getPCorPhone} from "../tools";

    export default {
        name: "service",
        data(){
            return {
                isPhone: false,
                list1: [
                    {img: ('http://img.cdboost.cn/cdboost/sy/serv11.png'), color:"#EB8843", title: '有序充电', text: "根据社区用电负荷，实时调控充电功率，确保配电安全"},
                    {img: ('http://img.cdboost.cn/cdboost/sy/serv12.png'), color:"#5EA8DC", title: '预约充电', text: "错峰充电，提高能效"},
                    {img: ('http://img.cdboost.cn/cdboost/sy/serv13.png'), color:"#ED413C", title: '主动安全防护', text: "具备8重安全防护，全方位保护", cls: 'min'},
                    {img: ('http://img.cdboost.cn/cdboost/sy/serv14.png'), color:"#1EAD46", title: '远程控制', text: "远程启停/远程调整充电功率/实时监测/大数据分析", cls: 'min'},
                ],
                list2: [
                    {img: ('http://img.cdboost.cn/cdboost/sy/serv21.png'), color:"#00A3E3", title: '多类型接入', text: "充电桩支持NB-Iot/LoRaWAN/WIFI方式的接入，适用于各种复杂应用场景", cls: 'min'},
                    {img: ('http://img.cdboost.cn/cdboost/sy/serv22.png'), color:"#00AAB1", title: '安全保护', text: "拥有过流、过压、过载自动断电保护", cls: 'min'},
                    {img: ('http://img.cdboost.cn/cdboost/sy/serv23.png'), color:"#F04C43", title: '脱网充电', text: "在网络暂时中断条件下，依然可以继续提供充电服务"},
                    {img: ('http://img.cdboost.cn/cdboost/sy/serv24.png'), color:"#6ABC33", title: '施工方便', text: "设备安装方便，无需调试，通电即用"},
                ],
                list3: [
                    {img: ('http://img.cdboost.cn/cdboost/sy/serv31.png'), color:"#EB8843", title: '脱网充电', text: "在网络条件暂时中断的条件下，设备依然可以继续提供充电服务"},
                    {img: ('http://img.cdboost.cn/cdboost/sy/serv32.png'), color:"#ED413C", title: '停电复充', text: "市电断电再复电，充电桩自动恢复充电服务"},
                    {img: ('http://img.cdboost.cn/cdboost/sy/serv33.png'), color:"#5EA8DC", title: '插头脱落', text: "插头松动或脱落，立即断电"},
                    {img: ('http://img.cdboost.cn/cdboost/sy/serv34.png'), color:"#1EAD46", title: '灵活参数', text: "设备支持按运营需要，灵活调整运行参数"},
                ]
            }
        },
        created() {
            this.isPhone = getPCorPhone();
        }
    }
</script>

<style scoped  lang="scss">
    .base {
        color: #333333;
        position: relative;
        overflow: hidden;
        background: white;
        .content{
            padding-top: 6em;
        }
        p{
            font-size: 1.5em;
            line-height: 2;
            text-indent: 2em;
        }
    }
    #ID21, #ID22, #ID23{
        background: url("http://img.cdboost.cn/cdboost/sy/serv1.jpg");
        height: 62em;
        width: 100%;
        background-size: 100% 100%;
        ul{
            padding: 1em 0;
        }
        li{
            height: 10em;
            width: 53em;
            background-size: 100% 100%;
            margin-top: 2em;
            margin-left: 2em;
            .title{
                font-size: 2em;
                padding-top: 0.5em;
                padding-left: 5.2em;
            }
            .text{
                font-size: 1.5em;
                padding-top: 0.5em;
                padding-left: 7em;
                line-height: 1.5;
                word-break:break-all;
            }
        }
    }
    #ID22{
        background: url("http://img.cdboost.cn/cdboost/sy/serv2.jpg") no-repeat;
        position: relative;
        background-color: #E2E7F1;
        background-size: 100% 100%;
        ul{
            position: absolute;
            right: 2em;
        }
        p{
            position: absolute;
            bottom: 2.5em;
            color: white;
        }
    }
    #ID23{
        background: url("http://img.cdboost.cn/cdboost/sy/serv3.png") no-repeat;
        background-size: 100% 100%;
        ul{
            display: flex;
            flex-wrap: wrap;
            position: absolute;
            bottom: 1em;
            li{
                margin-top: 1em;
            }
        }
        p{
            position: absolute;
            left: 72%;
            top: 50%;
            text-indent: 0;
        }
    }
    .isPhonePage {
        .title-box {
            font-size: 3.5rem;
            padding-top: 1rem;
        }
        #ID21, #ID22, #ID23{
            height: 70em;
            li{
                height: 13em;
                .title{
                    font-size: 11px;
                    padding-top: 5px !important;
                    padding-left: 5.2em;
                    line-height: 1;
                }
                .text{
                    font-size: 8px;
                    padding-top: 4px;
                    padding-left: 4em;
                    line-height: 1;
                }
            }
        }
        #ID23 p{
            position: absolute;
            left: 72%;
            top: 40%;
            line-height: 1;
            text-indent: 0;
            font-size: 10px;
        }
    }
</style>